export default function() {
   return {
      metadata: null,
      loaded: false,
   };
}
